<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <span v-on="{...tooltip}">
          <v-btn
            class="mr-1"
            small
            color="primary"
            dark
            v-on:click="()=>dialog=!dialog"
          >
            <v-icon>mdi-book-open-outline</v-icon>
          </v-btn>
        </span>
      </template>
      <span>{{$t('referenceBooks.devices.DeviceActionLog')}}</span>
    </v-tooltip>
    <DragForm
      v-model="dialog"
    >
      <v-card width="1000">
        <v-card-title>
          <span class="headline">{{$t('referenceBooks.devices.DeviceActionLog')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row style="height: 10%">
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  v-model="device.deviceName"
                  :label="this.$t('referenceBooks.devices.Name')"
                  disabled
                />
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                        v-model="device.bankName"
                        :label="this.$t('referenceBooks.banks.Name')"
                        disabled
                />
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                        v-model="device.branchName"
                        :label="this.$t('referenceBooks.branches.Name')"
                        disabled
                />
              </v-col>
              <v-col
                      style="overflow-y: auto;max-height: 350px"
                      cols="12" sm="12" md="12">
                <v-data-table
                        :headers="headers"
                        :items="logs"
                        :item-key="'logRecordId'"
                        disable-pagination
                        :no-data-text="$t('logs.NoLogsForDevice')"
                        hide-default-footer
                        fixed-header
                        height="100%"
                        show-expand
                        single-expand
                >
                  <template v-slot:item.objects="{item}">
                    <span v-if="item.objects.length === 1">
                      <span v-if="!!item.objects[0].branchName">
                        {{item.objects[0].branchName}}
                      </span>
                    </span>
                  </template>
                  <template v-slot:item.logDateTime="{item}">
                    {{item.logDateTime | formattedDate}}
                  </template>
                  <template v-slot:item.data-table-expand="{item, isExpanded, expand}">
                    <span v-if="item.objects.length && item.objects[0].productId && item.objects[0].productName">
                      <v-btn @click="() => expand(!isExpanded)" small icon>
                        <v-icon>
                          {{isExpanded ? 'mdi-arrow-up' : 'mdi-arrow-down'}}
                        </v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <template v-slot:expanded-item="{item}">
                    <td :colspan="headers.length">
                      <div class="pt-4">
                        <p v-for="product in item.objects"
                          :key="product.productId">
                          {{product.productId}} : {{product.productName}}
                        </p>
                      </div>

                    </td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="height: 10%">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">{{$t('Close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>

<script>
import formatDate from '@/services/dateFormatter';
import DragForm from '@/components/Forms/DragForm.vue';

export default {
  components: {
    DragForm,
  },
  name: 'DeviceLogsDialog',
  props: {
    device: {
      type: Object,
      defaultItem: {
      }
    }
  },
  data() {
    return {
      dialog: false,
      logs: [],
      expanded: []
    };
  },
  filters: {
    formattedDate(dateString) {
      return formatDate(dateString);
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.logs = [];
        this.expanded = [];
      } else {
        this.getData();
      }
    }
  },
  computed: {
    headers(){
      return [
        {text: this.$t('logs.LogMessage'), width: 250, value: 'logMessage', sortable: false},
        {text: this.$t('logs.DateTime'), value: 'logDateTime', sortable: false},
        {text: this.$t('logs.Name'), value: 'objects', sortable: false},
        {text: this.$t('logs.Username'), value: 'name', sortable: false},
        {text: '', value: 'data-table-expand' },
      ];
    }
  },
  methods: {

    async getData(){
      this.$axios.logs.getByDeviceId(this.device.deviceId)
        .then(response => response.data)
        .then(json => this.logs = json.logs)
        .catch(error => {
          console.error(error);
        });
    },
  },

};
</script>